export const formatDate = (date) => {
    if (!date) return "N/A";

    const d = new Date(date);
    if (isNaN(d.getTime())) return "N/A";

    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();

    return `${month}-${day}-${year}`;
};

export const formatDateForApi = (date) => {
    if (!date) return null;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};

export const formatDateForLabel = (date) => {
    if (!date) return null;

    const d = new Date(date);
    return `${d.toLocaleString("en-US", { month: "short" })}, ${String(
        d.getDate()
    ).padStart(2, "0")} ${d.getFullYear()}`;
};

export const formatDatePopup = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
};

export const formatCurrency = (value) => {
    if (!value || value === 0) return "N/A";
    return `$ ${Number(value).toFixed(2)}`;
};

